module.exports = __webpack_public_path__ + "img/9788936456511.52521ca0.jpg";